import { z } from "zod";

/**
 * Zod schema for a navigation item.
 *
 * Per Section 9 (Data Validation) of the developer guide we keep validation
 * close to the data source and use Zod (already a project dependency).
 */
export const NavItemSchema = z.object({
  // Accept any non‑empty string for href; URLs in navigation.json are relative paths.
  href: z.string().min(1),
  label: z.string(),
});

/**
 * Zod schema for a buzz‑word card.
 */
export const BuzzwordSchema = z.object({
  id: z.number(),
  title: z.string(),
  description: z.string(),
});

/**
 * Zod schema for contact information.
 */
export const ContactSchema = z.object({
  address: z.string().optional(),
  phone: z.string().optional(),
  email: z.string().email(),
  social: z.array(
    z.object({
      platform: z.string(),
      url: z.string().url(),
    }),
  ),
});
